import { IVideoSchema } from '../../../../../repositories/monolith-python/entities/offer/VideoSchema';
import { IOfferState } from '../../../../reducers';

export const mapVideos = (offer: IOfferState): Array<IVideoSchema> | null => {
  const { category, videos } = offer;

  // В новостройках не отсылаем видео
  if (category === 'newBuildingFlatSale') {
    return null;
  }

  return videos;
};
